import { AdvertisingEvent as PublicAdvertisingEvent } from '@foundation-player/runtime';

/**
 * {@inheritDoc AdvertisingEvent}
 */
export const AdvertisingEvent = {
  ...PublicAdvertisingEvent,

  /**
   * Ad slots are prepared for the advertising plugin
   * @internal
   */
  AdSlotsCreated: 'advertising:AdSlotsCreated',

  /**
   * Ad slot will be initialised
   *
   * @internal
   */
  InitAdSlot: 'advertising:InitAdSlot',

  /**
   * Advertisement slot is ready
   *
   * @internal
   */
  AdSlotReady: 'advertising:AdSlotReady',

  /**
   * Ad playback should be paused
   *
   * @internal
   */
  PauseAd: 'advertising:PauseAd',

  /**
   * Ad playback should be resumed
   *
   * @internal
   */
  ResumeAd: 'advertising:ResumeAd',

  /**
   * Ad playback should be skipped
   *
   * @internal
   */
  SkipAd: 'advertising:SkipAd',

  /**
   * Ad playback should be started
   *
   * @internal
   */
  StartAdSlot: 'advertising:StartAdSlot',

  /**
   * Ad playback should be stopped
   *
   * @internal
   */
  StopAdSlot: 'advertising:StopAdSlot',

  /**
   * Advertiser landing page should be opened
   *
   * @internal
   */
  OpenClickThrough: 'advertising:OpenClickThrough',

  /**
   * HOMAD was activated.
   *
   * @internal
   */
  HomadActivation: 'advertising:HomadActivation',

  /**
   * HOMAD was activated and blocked. Playout must be stopped.
   *
   * @internal
   */
  HomadPenalty: 'advertising:HomadPenalty',

  /**
   * The ad playout failed and will emit an {@link AdError} event.
   * A client should not listen on ad errors but should instead just listen on AdSlotCompleted.
   *
   * @internal
   */
  AdError: 'advertising:AdError',

  /**
   * Ad was played until the specified quartile.
   *
   * @remarks
   * This event is emitted for every ad clip up to three times.
   * The payload will be of type {@link AdQuartileReachedEvent}.
   *
   * The quartile is a number between 1 and 3 each marking 25%, 50% and 75% of the ad clip were played.
   *
   * @internal
   */
  AdQuartileReached: 'advertising:AdQuartileReached',
} as const;

export type AdvertisingEvent = (typeof AdvertisingEvent)[keyof typeof AdvertisingEvent];
